import React from "react";

import rightSide from "../../assets/images/Right_Side.png";
import logo from "../../assets/images/mG_logo.svg";
import {
  Container,
  FormAndLogoContainer,
  FormContainer,
  Image,
  ImageContainer,
  LogoContainer,
} from "./AuthLayout.style";
import { Link } from "react-router-dom";
import AppVersion from "../../components/AppVersion/AppVersion";

type Props = {
  children: React.ReactNode;
};

// Language: typescript
const AuthLayout: React.FC<Props> = ({ children }) => {
  const [form] = React.Children.toArray(children);
  return (
    // main container
    // remove this and this too
    <Container>
      {/* image container */}
      <ImageContainer>
        <Image src={rightSide} alt="image of smiling woman and girl" />
      </ImageContainer>
      {/* form and logo container */}
      <FormAndLogoContainer>
        {/* logo container */}
        <LogoContainer>
          <Link to="/">
            <img src={logo} alt="" />
          </Link>
        </LogoContainer>
        {/* end of logo container */}
        {/* form container */}
        <FormContainer>{form}</FormContainer>
        {/* end of form container */}

        {/* version display */}
        <div className="fixed bottom-4 right-4">
          <AppVersion className="text-xs text-gray-400" showTooltip={true} />
        </div>
      </FormAndLogoContainer>
      {/* end of form and logo container */}
    </Container>
  );
};

export default AuthLayout;
